import { z } from 'zod';

/**
 * `GET /orgs/:orgId/mcp/connector` — the three strings a member pastes into
 * claude.ai to add the connector. One Auth0 client serves every organization,
 * so the values are the deployment's, not the org's.
 *
 * Safe to show any member: the secret is no boundary (ruled 2026-10-03). What a
 * connected member may read is their own sign-in and membership, checked per call.
 * A `null` is a value this deployment has not mounted.
 */
export const ConnectorView = z.object({
  url: z.string().nullable(),
  client_id: z.string().nullable(),
  client_secret: z.string().nullable(),
});
export type ConnectorView = z.infer<typeof ConnectorView>;
